<template>
	<div>
		<!-- PC导航 -->
		<div class="pc black">
			<div class="head">
				<div class="logo" @click="url('/')">
					<img :src="config.logo">
				</div>
				<div class="nav black">
					<div class="nav-item">
						<li v-for="(item,index) in data" :key="index">
							<a class="item" :class="active==index?'active':''" href="javascript:;" @click="url(item.href)">
								{{item.name}}
							</a>
						</li>
					</div>
					<div class="search">
						<input type="text" v-model="keyword" class="search-input" @change="search" @input="search"  placeholder="请输入搜索关键词">
						<i class="el-icon-search search-icon"></i>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		common_nav,
		common_config
	} from '@/api/common.js';
	export default {
		name: 'commonHead',
		props: {
			active: 0,
			state: 0,
		},

		data() {
			return {
				config: {},
				data: [],
				keyword:'',
			}
		},
		mounted () {
			this.keyword = this.$route.query.keyword;
		},
		created() {
			this.get_data();
			this.get_config();
		},
		methods: {
			get_data() {
				common_nav({
					nav_id: 1
				}).then(res => {
					if (res.code == 1) {
						this.data = res.data;
					}
				});
			},
			get_config() {
				common_config({}).then(res => {
					if (res.code == 1) {
						this.config = res.data;
					}
				});
			},
			url(path) {
				window.location.href = path;
			},

			//搜索
			search(e){
				var keyword = e.target.value;
				if(this.$route.path=='/search'){
					this.$emit('search',keyword);
				}else{
					this.$router.push('/search?keyword=' + keyword);
				}
			},
		}
	}
</script>
<style lang="less" scoped>
	.black2{
		border-bottom: 2px solid #a0ca32;
	}
	.head {
		height: 168px;
		width: 100%;
		min-width: 1300px;
		position: relative;
		
	}

	.logo {
		width: 350px;
		height: 168px;
		position: absolute;
		left: 0;
		top: 20px;
		text-align: center;
		line-height: 168px;
        cursor: pointer;
	}

	.logo img {
		height: 80px;
		margin-left: 50px;
	}
	.search{
		position: relative;
		float: right;
		width: 450px;
		line-height: 168px;
		height: 168px;
		margin-right: 50px;
	}
	.nav-item{
		float: right;
	}
	.nav {
		height: 168px;
		min-width: 500px;
		width: auto;
		text-align: center;
		position: absolute;
		left: 350px;
		top: 0;
		overflow: hidden;
		text-align: right;
		width:calc(100% - 450px);
	}
	.black{
		color: #333;
	}
	.nav ul {
		padding: 0;
		margin: 0;
	}

	.nav li {
		list-style: none;
		display: inline-block;
		margin-right: 20px;
		height: 168px;
	}

	.button {
		width: 300px;
		height: 168px;
		text-align: center;
		position: absolute;
		right: 0;
		top: 0;
		line-height: 168px;
	}

	.button img {
		margin-left: 50px;
		height: 26px;
	}
	.black .active{
		color: #a0ca32!important;
		border-bottom: 3px solid #a0ca32;
	}
	.black .item{
		color: #333;
	}

	.black .item:hover {
		color: #a0ca32;
		font-weight: 600;
		border-bottom: 3px solid #a0ca32;
	}
	.item {
		color: #fff;
		font-size: 17px;
		text-decoration: none;
		display: inline-block;
		height: 40px;
		line-height: 40px;
		padding: 0 30px;
		margin-top: 64px;
		margin-left: 30px;
	}

	.active {
		color: #fff;
		font-weight: 600;
		border-bottom: 3px solid #fff;
	}

	.item:hover {
		color: #fff;
		font-weight: 600;
		border-bottom: 3px solid #fff;
	}

	.search-input{
		width: 400px;
		height: 40px;
		border: none;
		background-color: #fff;
		border-radius: 20px;
		outline: none;
		padding-left: 15px;
	}
	.search-input:hover{
		border: none;
	}
	.search-icon{
		position: absolute;
		right: 15px;
		top: 74px;
		font-size: 26px;
		color: #aaa;
	}
</style>
